import { useQuery } from '@tanstack/react-query';
import { databases, databaseId } from '@/lib/appwrite';
import { Query } from 'appwrite';

interface Category {
  $id: string;
  slug?: string;
  name: string;
  description: string;
  order?: number;
  $createdAt: string;
  $updatedAt: string;
}

const categoriesCollectionId = 'categories'; // Ajustar según tu colección

export const useCategories = () => {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const response = await databases.listDocuments(
        databaseId,
        categoriesCollectionId,
        [Query.limit(100), Query.orderAsc('order')]
      );
      return response.documents as any as Category[];
    },
  });
};